import LoadGroupLegs from "./LoadGroupLegs";

export default LoadGroupLegs;